<template>
	<div v-if="visible" class="map-route">
		<leaflet-line
			v-for="(place, index) of route"
			:key="index"
			v-bind="$attrs"
			:visible="visible"
			:start="place.start"
			:end="place.end"
		/>
	</div>
</template>

<script>
export default {
	name: 'MapRoute',
	props: {
		route: {
			type: Array,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		}
	}
};
</script>
